import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { CHECKOUT_URL } from '../../utils/checkout';
import { pricingRows, pricingTrustItems } from '../../data/pricing';
export function Pricing() {
  return <section id="oferta-base" className="bg-bg-secondary py-10 sm:py-14" data-id="element-172" data-mp="3gijjanzpi1ed">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-173" data-mp="3gkmhvwexd2up">
        <SectionTag icon="💰" data-id="element-174" data-mp="3lhcuuavfnibw">Oferta Especial</SectionTag>
        <h2 className="mt-4 font-heading text-3xl font-extrabold uppercase leading-tight text-ink sm:text-4xl" data-id="element-175" data-mp="3piyfwji4f2x6">
          ¿Cuánto vale para ti recuperar tus domingos?
        </h2>
        <p className="mt-3 text-base text-muted sm:text-lg" data-id="element-176" data-mp="3c9luf2cim67">
          Acceso inmediato y garantía total de 7 días.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-md px-4 sm:px-6" data-id="element-177" data-mp="205l8umimj0sd">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="rounded-3xl border border-flash/25 bg-bg-primary p-6 shadow-card sm:p-7" data-id="element-178" data-mp="253mrj6c50y3b">
          <p className="font-heading text-xs font-bold uppercase tracking-wider text-muted" data-id="element-179" data-mp="16i70cwhet21r">
            🎯 EDUCACIÓN FÍSICA FLASH: Sistema Completo
          </p>
          <p className="mt-1.5 text-xs text-muted" data-id="element-180" data-mp="xkmvzeo92pmx">6 tomos + 6 bonos, listos para llevar al patio.</p>

          <div className="mt-4 space-y-1.5" data-id="element-181" data-mp="1u8b0gtve2jo0">
            {pricingRows.map(row => <div key={row.content} className="flex items-center justify-between gap-3 border-b border-slate-100 py-1.5 text-sm" data-id="element-182" data-mp="1pbkpum2csg9z">
                <span className="text-ink/80" data-id="element-183" data-mp="1gacry53r1hgf">{row.content}</span>
                <span className="flex flex-shrink-0 items-center gap-2" data-id="element-184" data-mp="1gc5xti6jfxnd">
                  {row.value !== '—' && <span className="text-muted" data-id="element-185" data-mp="9reipuetv1xv">{row.value}</span>}
                  <CheckIcon size={14} className="text-success" data-id="element-186" data-mp="4tv24nunqd2r" />
                </span>
              </div>)}
            <div className="flex items-center justify-between py-1.5 text-sm font-bold text-ink" data-id="element-187" data-mp="69qt86h9whsi">
              <span data-id="element-188" data-mp="b8tztvcwiw2l">VALOR TOTAL</span>
              <span data-id="element-189" data-mp="3tgt3n6mji0si">169,60€</span>
            </div>
          </div>

          <p className="mt-4 text-xs font-medium text-muted" data-id="element-190" data-mp="3tim2w0utpiqh">Precio hoy (88% de descuento):</p>
          <p className="font-heading text-5xl font-extrabold text-flash sm:text-6xl" data-id="element-191" data-mp="1etnb8faioju">17,99€</p>
          <p className="mt-2 inline-flex items-center gap-1.5 rounded-full bg-yellow px-3 py-1 text-xs font-bold text-navy sm:text-sm" data-id="element-192" data-mp="3jpexig0322qe">
            ⏰ Precio de lanzamiento — subirá pronto
          </p>

          <div className="mt-6" data-id="element-193" data-mp="39qh4p0vmjn1l">
            <a href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-2 rounded-xl bg-orange px-8 py-4 font-heading text-base font-bold uppercase tracking-wide text-white shadow-card transition-all duration-200 hover:bg-orange-hover active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-orange focus-visible:ring-offset-2 focus-visible:ring-offset-bg-primary sm:text-lg" data-id="element-194" data-mp="3erdflyee89gi">
              Quiero EDUCACIÓN FÍSICA FLASH por 17,99€
            </a>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-muted" data-id="element-195" data-mp="2v769ictljt5a">
            {pricingTrustItems.map(item => <span key={item.label} className="flex items-center gap-1" data-id="element-196" data-mp="353hml510gn0s">
                <item.icon size={12} data-id="element-197" data-mp="351oinxhs8gwh" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}